import React, { useState } from "react";
import { useSelector } from "react-redux";

import Button from "../../components/Button";
import messages from "../../assets/locale/messages";
import { performCompanyPendingApprovalLogout } from "../../utils/companyRegistration";

/**
 * Header control for `/company/pending-approval` — renders next to the auth language switch.
 */
const CompanyPendingApprovalLogoutButton = () => {
  const lang = useSelector((state) => state.locale.lang);
  const [busy, setBusy] = useState(false);
  const { shared } = messages[lang];

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await performCompanyPendingApprovalLogout();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      label={shared.logout}
      outlined
      small
      disabled={busy}
      onClick={handleClick}
      className="auth-layout__header-logout"
    />
  );
};

export default CompanyPendingApprovalLogoutButton;
